import React from 'react';
import { Translation } from 'react-i18next';
import { Tag } from 'antd';

const BooleanTag = ({ value, ...props }) => {
  return (
    <Translation>
      {(t) => (
        <Tag color={value ? 'green' : 'red'}>
          {value ? t('boolean_true') : t('boolean_false')}
        </Tag>
      )}
    </Translation>
  );
};

const LearningTypeTag = ({ value, ...props }) => {
  return (
    <Translation>
      {(t) => (
        <Tag color={value ? 'warning' : 'geekblue'}>
          {value
            ? t('learning_type_recommended')
            : t('learning_type_not_recommended')}
        </Tag>
      )}
    </Translation>
  );
};

const PublicStatusTag = ({ value, ...props }) => {
  const labels = {
    1: 'learning_public_status_published',
    2: 'learning_public_status_draft',
    3: 'learning_public_status_archived',
  };

  const colors = {
    1: 'success',
    2: 'blue',
    3: 'default',
  };

  return (
    <Translation>
      {(t) => <Tag color={colors[value]}>{t(labels[value])}</Tag>}
    </Translation>
  );
};

const RoleTag = ({ role, ...props }) => {
  const labels = {
    1: 'registration_code_role_owner',
    2: 'registration_code_role_admin',
    3: 'registration_code_role_client',
    4: 'registration_code_role_default',
  };

  const colors = {
    1: 'success',
    2: 'processing',
    3: 'warning',
    4: 'default',
  };
  return (
    <Translation>
      {(t) => <Tag color={colors[role]}>{t(labels[role])}</Tag>}
    </Translation>
  );
};

const StatusTag = ({ status, ...props }) => {
  const labels = {
    1: 'status_enabled',
    2: 'status_disabled',
    3: 'status_archived',
    4: 'status_deleted',
    5: 'status_pending',
  };

  const colors = {
    1: 'success',
    2: 'default',
    3: 'warning',
    4: 'error',
    5: 'processing',
  };

  return (
    <Translation>
      {(t) => <Tag color={colors[status]}>{t(labels[status])}</Tag>}
    </Translation>
  );
};

const ColorTag = ({ color, ...props }) => {
  return <Translation>{(t) => <Tag color={color}>{color}</Tag>}</Translation>;
};

const StateCardTag = ({ value }) => {
  const labels = {
    0: 'learning_module_state_not_started',
    1: 'learning_module_state_viewed',
    2: 'learning_module_state_completed',
  };

  const classMap = {
    0: 'pill pill-not-started',
    1: 'pill pill-viewed',
    2: 'pill pill-completed',
  };

  return (
    <Translation>
      {(t) => <div className={classMap[value]}>{t(labels[value])}</div>}
    </Translation>
  );
};

export {
  StateCardTag,
  BooleanTag,
  StatusTag,
  RoleTag,
  ColorTag,
  LearningTypeTag,
  PublicStatusTag,
};
